module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-left-normal-big.55a31245.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-left-normal-big.png
// module id = 2641
// module chunks = 11